var _defs, _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _g5, _path5, _path6, _path7, _path8, _path9, _path10, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApillowcaseonepillow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101.42pt",
    height: "56.056pt",
    viewBox: "0 0 101.42 56.056",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.19 478h13.312v9h-13.312z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.19 477.89h13.312v9.1523h-13.312z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.19 478h13.312v9h-13.312z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.19 477.89h13.312v9.1523h-13.312z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-221.93 -465.45)",
    fill: "none",
    stroke: "#6b645b",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m2252.8 977.65 311.52-124.49s33.867-14.609 68.086 1.0156l573.59 262.11",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 3.864
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m2220.6 1005v-105.47c0.8984-8.0469 9.2188-17.383 32.227-27.305l311.6-128.05-0.078-0.11719s36.367-12.422 70.547 3.2031"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m3206 1116.3c56.289 25.703 4.4531 44.922 4.4531 44.922l-313.05 100.43c-32.93 11.758-59.453 0.2734-59.453 0.2734l-590.66-229.57s-63.828-24.766 5.5078-54.688"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m3232.1 1142v-99.57c-0.8984-6.5625-7.7734-15.43-26.133-23.867l-573.55-272.38"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m99.342 12.568s-3.0742 4.7383-9.875 8.8711l-3-2.3867s8.5039-6.4023 9.0234-6.4531c0.51953-0.0469 3.8516-0.0312 3.8516-0.0312",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m99.342 12.568s-3.0742 4.7383-9.875 8.8711l-3-2.3867s8.5039-6.4023 9.0234-6.4531c0.51953-0.04687 3.8516-0.03125 3.8516-0.03125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m99.342 12.568s-3.0742 4.7383-9.875 8.8711l-3-2.3867s8.5039-6.4023 9.0234-6.4531c0.51953-0.0469 3.8516-0.0312 3.8516-0.0312",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m99.342 12.568s-3.0742 4.7383-9.875 8.8711l-3-2.3867s8.5039-6.4023 9.0234-6.4531c0.51953-0.04687 3.8516-0.03125 3.8516-0.03125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-221.93 -465.45)",
    clipPath: "url(#clip-11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.27 478.02s-3.0742 4.7383-9.875 8.8711l-3-2.3867s8.5039-6.4023 9.0234-6.4531c0.51953-0.0469 3.8516-0.0312 3.8516-0.0312",
    fill: "#6b645b"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-221.93 -465.45)",
    clipPath: "url(#clip-12)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m3212.7 1173s-30.742-47.383-98.75-88.711l-30 23.867s85.039 64.023 90.234 64.531c5.1953 0.4687 38.516 0.3125 38.516 0.3125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-221.93 -465.45)",
    clipPath: "url(#clip-13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.27 478.02s-3.0742 4.7383-9.875 8.8711l-3-2.3867s8.5039-6.4023 9.0234-6.4531c0.51953-0.0469 3.8516-0.0312 3.8516-0.0312",
    fill: "#6b645b"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-221.93 -465.45)",
    clipPath: "url(#clip-14)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m3212.7 1173s-30.742-47.383-98.75-88.711l-30 23.867s85.039 64.023 90.234 64.531c5.1953 0.4687 38.516 0.3125 38.516 0.3125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m99.342 12.568s-3.0742 4.7383-9.875 8.8711l-3-2.3867s8.5039-6.4023 9.0234-6.4531c0.51953-0.04687 3.8516-0.03125 3.8516-0.03125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m99.342 12.568s-3.0742 4.7383-9.875 8.8711l-3-2.3867s8.5039-6.4023 9.0234-6.4531c0.51953-0.0469 3.8516-0.0312 3.8516-0.0312",
    fill: "#ddd9ce"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m99.342 12.568s-3.0742 4.7383-9.875 8.8711l-3-2.3867s8.5039-6.4023 9.0234-6.4531c0.51953-0.04687 3.8516-0.03125 3.8516-0.03125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m89.482 21.698 1.0859-1.8555c0.21484-0.36719 0.52344-0.73438 0.91797-1.0742l4.0117-3.4961c0.39453-0.34375 0.86328-0.66016 1.3828-0.92969l2.6211-1.3711c0.38672-0.20312 0.43359-0.52734 0.0859-0.58594l-3.5039-0.59766-30.246-10.254-2.6367-1.3516c-0.26562-0.13281-0.79297 0.043-0.95312 0.31641l-1.0234 1.7539c-0.21484 0.36719-0.52344 0.73438-0.91797 1.0742l-4.2188 3.6758c-0.39453 0.34375-0.85938 0.65625-1.3789 0.92969l-2.4766 1.293c-0.38672 0.20312-0.4375 0.53125-0.0898 0.58984l2.9297 0.49609c0.17969 0.0312 0.35156 0.0742 0.51172 0.125l30.301 10.27c0.16016 0.0508 0.30859 0.11328 0.44531 0.18359l2.2031 1.125c0.26172 0.13672 0.79297-0.0391 0.94922-0.31641",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m89.482 21.698 1.0859-1.8555c0.21484-0.36719 0.52344-0.73438 0.91797-1.0742l4.0117-3.4961c0.39453-0.34375 0.86328-0.66016 1.3828-0.92969l2.6211-1.3711c0.38672-0.20312 0.43359-0.52734 0.08594-0.58594l-3.5039-0.59766-30.246-10.254-2.6367-1.3516c-0.26562-0.13281-0.79297 0.04297-0.95312 0.31641l-1.0234 1.7539c-0.21484 0.36719-0.52344 0.73438-0.91797 1.0742l-4.2188 3.6758c-0.39453 0.34375-0.85938 0.65625-1.3789 0.92969l-2.4766 1.293c-0.38672 0.20312-0.4375 0.53125-0.08985 0.58984l2.9297 0.49609c0.17969 0.03125 0.35156 0.07422 0.51172 0.125l30.301 10.27c0.16016 0.05078 0.30859 0.11328 0.44531 0.18359l2.2031 1.125c0.26172 0.13672 0.79297-0.03906 0.94922-0.31641z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m89.492 21.818 1.082-1.8555c0.21094-0.36719 0.52344-0.73438 0.91797-1.0781l4.0117-3.4922c0.39453-0.34375 0.86328-0.66016 1.3828-0.92969l2.6211-1.3711c0.38672-0.20312 0.43359-0.53125 0.0859-0.58984l-3.5039-0.59375-30.25-10.258h4e-3l-2.6406-1.3477c-0.26172-0.13672-0.78906 0.0391-0.94922 0.31641l-1.0234 1.7539c-0.21484 0.36719-0.52734 0.73047-0.92188 1.0742l-4.2148 3.6719c-0.39453 0.34375-0.85938 0.66016-1.3789 0.93359l-2.4805 1.293c-0.38672 0.20312-0.43359 0.52734-0.0859 0.58984l2.9297 0.49609c0.17969 0.0312 0.35156 0.0703 0.51172 0.12109l30.297 10.273c0.16406 0.0508 0.3125 0.11328 0.44922 0.17969l2.2031 1.1289c0.26172 0.13281 0.78906-0.043 0.95312-0.31641",
    fill: "#ddd9ce"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6b645b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.492 21.818 1.082-1.8555c0.21094-0.36719 0.52344-0.73438 0.91797-1.0781l4.0117-3.4922c0.39453-0.34375 0.86328-0.66016 1.3828-0.92969l2.6211-1.3711c0.38672-0.20312 0.43359-0.53125 0.08594-0.58984l-3.5039-0.59375-30.25-10.258h0.0039l-2.6406-1.3477c-0.26172-0.13672-0.78906 0.03906-0.94922 0.31641l-1.0234 1.7539c-0.21484 0.36719-0.52734 0.73047-0.92188 1.0742l-4.2148 3.6719c-0.39453 0.34375-0.85938 0.66016-1.3789 0.93359l-2.4805 1.293c-0.38672 0.20312-0.43359 0.52734-0.08593 0.58984l2.9297 0.49609c0.17969 0.03125 0.35156 0.07031 0.51172 0.12109l30.297 10.273c0.16406 0.05078 0.3125 0.11328 0.44922 0.17969l2.2031 1.1289c0.26172 0.13281 0.78906-0.04297 0.95312-0.31641z",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.502 21.818 1.082-1.8594c0.21484-0.36719 0.52344-0.73047 0.92188-1.0742l4.0078-3.4961c0.39453-0.33984 0.86328-0.65625 1.3828-0.92969l2.6211-1.3672c0.39062-0.20312 0.4375-0.53125 0.08984-0.58984l-3.5078-0.59766v0.0039l-30.246-10.258h0.0039l-2.6406-1.3477c-0.26172-0.13672-0.79297 0.03906-0.95312 0.3125l-1.0195 1.7539c-0.21484 0.37109-0.52734 0.73438-0.92188 1.0781l-4.2148 3.6719c-0.39453 0.34375-0.86328 0.66016-1.3828 0.92969l-2.4766 1.2969c-0.38672 0.20312-0.4375 0.52734-0.08594 0.58594l2.9258 0.5c0.17969 0.02734 0.35156 0.07031 0.51172 0.12109l30.301 10.273c0.16016 0.05078 0.30859 0.10938 0.44531 0.17969l2.2031 1.1289c0.26562 0.13281 0.79297-0.04297 0.95312-0.31641z",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-221.93 -465.45)",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m3070.5 5230.5 11.328 19.492c2.2656 3.8672 5.5469 7.6953 9.6875 11.289l42.07 36.68c4.1406 3.5938 9.0625 6.9141 14.492 9.7266l27.539 14.414c4.0625 2.1094 4.5703 5.5469 0.8984 6.1719l-36.758 6.25v-0.039l-317.42 107.62 0.039 0.039-27.695 14.141c-2.7734 1.4062-8.3203-0.4297-10-3.3203l-10.742-18.398c-2.2266-3.8281-5.5078-7.6953-9.6484-11.289l-44.219-38.555c-4.1406-3.5938-9.0625-6.875-14.492-9.7266l-26.016-13.594c-4.0625-2.1094-4.5703-5.5469-0.8984-6.1719l30.703-5.2344c1.9141-0.3125 3.7109-0.7422 5.3906-1.2891l317.93-107.77c1.6797-0.5469 3.2422-1.1719 4.6875-1.9141l23.125-11.836c2.7734-1.4062 8.3203 0.4297 10 3.3203z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 3.864
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m3841.5 963.98 384.38-142.85s30.195-13.047 60.664 0.89844l511.37 233.63"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m3812.8 988.36v-93.984c0.7813-7.1875 8.2031-15.508 28.711-24.375l384.41-146.02-0.039-0.0781s32.383-11.055 62.891 2.8516"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m3841.5 963.98c-61.797 26.641-4.9219 48.75-4.9219 48.75l526.56 204.65s23.633 10.234 53.008-0.2344l385.7-121.45s46.211-17.109-3.9453-40.039"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m4821.2 1078.6v-88.75c-0.8203-5.8594-6.9141-13.789-23.281-21.25l-511.33-242.85"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApillowcaseonepillow);
export default __webpack_public_path__ + "static/media/apillowcaseonepillow.40cc1f603b39116b028164ce74475d90.svg";
export { ForwardRef as ReactComponent };